/**
 * Log one use of an "open the classic page" escape on a new page (parity
 * audit 11/3). Lands in audit_events as `user.page_escape_to_classic`, so the
 * next audit can see exactly what made people leave the new page.
 * Fire and forget: a failed log never gets in the way of the click.
 */
import { api } from "@/lib/api";

export type EscapeFrom = "job_page_fresh" | "grid_new" | "requests_new";

export function logPageEscape(from: EscapeFrom, item: string, jobId?: string): void {
    void api.post("/api/me/page-escape", { from, item, ...(jobId ? { jobId } : {}) }).catch(() => undefined);
}
